// extracted by mini-css-extract-plugin
export var cancelButton = "_p4-5";
export var content = "_p4-3";
export var createButton = "_p4-6";
export var drawerContainer = "_p4-0";
export var footer = "_p4-2";
export var header = "_p4-1";
export var orderFormColumn = "_p4-4";